import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Maintenance() {
  const [branches, setBranches] = useState([]);
  useEffect(() => { api.get("/branches").then(({ data }) => setBranches(data)); }, []);
  return (
    <ResourcePage
      endpoint="/maintenance"
      testidPrefix="maintenance"
      eyebrow="Operations"
      title="Maintenance Management"
      subtitle="Preventive maintenance, breakdown reports and technician assignments."
      ctaLabel="New work order"
      fields={[
        { name: "equipment", label: "Equipment", required: true, placeholder: "Cold-room compressor #2" },
        { name: "issue_description", label: "Issue description", type: "textarea", required: true },
        { name: "branch", label: "Branch", type: "select", required: true, options: branches.map((b) => b.name) },
        { name: "technician", label: "Assigned technician" },
        { name: "scheduled_date", label: "Scheduled date", type: "date" },
        { name: "cost", label: "Est. cost (UGX)", type: "number" },
        { name: "status", label: "Status", type: "select", default: "requested",
          options: ["requested", "scheduled", "in_progress", "completed"] },
        { name: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "equipment", label: "Equipment" },
        { key: "branch", label: "Branch" },
        { key: "technician", label: "Technician" },
        { key: "scheduled_date", label: "Scheduled" },
        { key: "cost", label: "Cost", render: (i) => i.cost ? `UGX ${Number(i.cost).toLocaleString()}` : "—" },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "completed" ? "emerald" : i.status === "in_progress" ? "blue" : "amber"}>{i.status?.replaceAll("_", " ")}</Badge> },
      ]}
      searchKeys={["equipment", "branch", "technician"]}
    />
  );
}
